import type { ModulesAndAgendasState } from '../index';
import { findSectionIndex, findTabIndex } from 'utils/section/tabSection';

interface Payload {
  sectionName: string;
  fromTab: number;
  toTab: number;
}

export const moveSectionToTab = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { sectionName, fromTab, toTab } = payload;

  if (fromTab === toTab) return;

  const fromTabIndex = findTabIndex(state.tabSections, fromTab);
  const toTabIndex = findTabIndex(state.tabSections, toTab);

  if (fromTabIndex === -1 || toTabIndex === -1) return;

  const sectionIndex = findSectionIndex(state.tabSections[fromTabIndex].sections, sectionName);

  if (sectionIndex === -1) return;

  const [moved] = state.tabSections[fromTabIndex].sections.splice(sectionIndex, 1);
  state.tabSections[toTabIndex].sections.push(moved);

  if (state.tabSections[fromTabIndex].sections.length === 0 && state.tabSections.length > 1) {
    state.tabSections.splice(fromTabIndex, 1);
    state.tabSections.forEach((tabSection, index) => {
      tabSection.tab.number = index;
    });
  }
};
